import type { RouteRecordRaw } from 'vue-router';

import SiteSystemsView from '@/Core.Service.Domain/Sites/SiteSystems/Views/IndexView.vue';

export const SiteSystemsRoute: RouteRecordRaw = {
  path: '/site/site-systems',
  name: 'SiteSystems',
  component: SiteSystemsView,
  meta: {
    label: 'Site Systems',
    toolTip: 'Site System',
    placeholder: 'Search for a System',
    permission: 'sites:read',
  },
};

export const SiteSystemsCreateRoute: RouteRecordRaw = {
  path: '/site/site-systems/create',
  name: 'SiteSystemsCreate',
  component: () =>
    import('@/Core.Service.Domain/Sites/SiteSystems/Views/CreateSiteSystem.vue'),
  meta: {
    label: 'Create Site System',
    permission: 'sites:create',
  },
};

export const SiteSystemsEditRoute: RouteRecordRaw = {
  path: '/site/site-systems/edit/:id',
  name: 'SiteSystemsEdit',
  component: () =>
    import('@/Core.Service.Domain/Sites/SiteSystems/Views/EditSiteSystem.vue'),
  meta: {
    label: 'Edit Site System',
    permission: 'sites:update',
  },
};
